const module = { name: 'fd-location/localeDetector', exports: {} }; const exports = module.exports;



import { Fandango_cookie as Fandango_cookie_get_getCookie } from '@grins/fd-modules/splits/onering-global';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { Fandango_sanitizer as sanitizer } from '@grins/fd-modules/splits/onering-global';



import { fd_location_countrySwitcher as countrySwitcher } from '@grins/fd-modules/splits/onering-global';



import { fd_location_regionSelector as regionSelector } from '@grins/fd-modules/splits/onering-global';



const AKAMAI_LOCATION_COOKIE = 'akamai_generated_location'


const USER_COUNTRY_COOKIE = 'userCountry'


const STORAGE_KEY = 'fd_region_switch_dismissed'


const HOST_DISMISS_KEY = 'fd_region_host_mismatch_dismissed'


const SUPPORTED_COUNTRIES = ['GB', 'IE', 'US']


let listenerAttached = false
function isDismissed() {
    try {
        return !!sessionStorage.getItem(STORAGE_KEY);
    }
    catch (e) {
        return false;
    }
}
function setDismissed() {
    try {
        sessionStorage.setItem(STORAGE_KEY, '1');
    }
    catch (e) {
    }
}
function isHostDismissed() {
    try {
        return !!localStorage.getItem(HOST_DISMISS_KEY);
    }
    catch (e) {
        return false;
    }
}
function setHostDismissed() {
    try {
        localStorage.setItem(HOST_DISMISS_KEY, '1');
    }
    catch (e) {
    }
}
function getAkamaiCountry() {
    const akamaiCookie = getCookie(AKAMAI_LOCATION_COOKIE);
    if (!akamaiCookie) {
        return null;
    }
    let decoded = sanitizer.text(akamaiCookie);
    if (decoded && decoded.charAt(0) !== '{') {
        try {
            decoded = decodeURIComponent(decoded);
        }
        catch (e) {
        }
    }
    try {
        const parsed = JSON.parse(decoded);
        return parsed?.countrycode?.toUpperCase() || null;
    }
    catch (e) {
        const match = decoded.match(/"countrycode"\s*:\s*"([A-Za-z]{2})"/);
        return match ? match[1].toUpperCase() : null;
    }
}
function promptIfMismatch(detectedCountry) {
    if (isDismissed()) {
        return;
    }
    if (!detectedCountry || !SUPPORTED_COUNTRIES.includes(detectedCountry)) {
        return;
    }
    const currentCountry = countrySwitcher.getCurrentCountry();
    if (detectedCountry === currentCountry) {
        return;
    }
    setDismissed();
    regionSelector.showSwitchModal(currentCountry, detectedCountry);
}
function onRegionMismatch(e) {
    const { country } = e.detail || {};
    if (!country) {
        return;
    }
    const detectedCountry = country.toUpperCase();
    if (!SUPPORTED_COUNTRIES.includes(detectedCountry)) {
        return;
    }
    const currentCountry = countrySwitcher.getCurrentCountry();
    if (detectedCountry === currentCountry) {
        return;
    }
    regionSelector.showSwitchModal(currentCountry, detectedCountry);
}
function checkHostMismatch() {
    if (isHostDismissed()) {
        return false;
    }
    const rawCookie = getCookie(USER_COUNTRY_COOKIE);
    if (!rawCookie) {
        return false;
    }
    const cookieCountry = countrySwitcher.getCurrentCountry();
    const expectedCountries = countrySwitcher.getLocalCountries();
    if (expectedCountries.includes(cookieCountry)) {
        return false;
    }
    const hostDefaultCountry = countrySwitcher.getDefaultCountry();
    regionSelector.showSwitchModal(hostDefaultCountry, cookieCountry, {
        onDismiss: () => {
            setHostDismissed();
            countrySwitcher.switchCountry(hostDefaultCountry);
        },
    });
    return true;
}
function init() {
    if (checkHostMismatch()) {
        return;
    }
    if (!listenerAttached) {
        document.addEventListener('fd:regionMismatch', onRegionMismatch);
        listenerAttached = true;
    }
    const akamaiCountry = getAkamaiCountry();
    promptIfMismatch(akamaiCountry);
}
module.exports = { init, checkHostMismatch };
export default module.exports;